export const snakeCaseToSentenceCase = (text: string | null | undefined) => {
  if (!text) {
    return "";
  }

  let formattedText = text
    .split("_")
    .filter(Boolean)
    .map((w) => w.toLowerCase())
    .map((w) => {
      const l1 = w.split("")[0]!.toUpperCase();
      const remaining = w.split("").slice(1);
      // oxlint-disable-next-line no-misused-spread
      return [...l1, ...remaining].join("");
    })
    .join(" ");

  if (formattedText.includes("Acos")) {
    formattedText = formattedText.replace("Acos", "ACOS");
  }

  return formattedText;
};

export const cut = <T extends string | null | undefined>(text: T, maxLength: number) => {
  if (!text) {
    return text;
  }

  if (text.length < maxLength) {
    return text;
  }

  let len = 0;
  for (let i = 0; i < text.length; i++) {
    const char = text.slice(i, i + 1);
    len++;

    if (len < maxLength) {
      continue;
    }

    if (len >= maxLength && char === " ") {
      return `${text.slice(0, len - 1)}...`;
    }
  }

  return text;
};

export const toTitleCase = (str: string | null | undefined) => {
  if (!str) {
    return "";
  }
  return str.replaceAll(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
  });
};

export const isValidDataframeDate = (d: unknown): d is string => {
  if (d === undefined) {
    return false;
  }

  if (d === null) {
    return false;
  }

  if (d === 0) {
    return false;
  }

  if (typeof d !== "string") {
    return false;
  }
  if (d.length !== 10) {
    return false;
  }

  if (isNaN(parseInt(d.slice(0, 4)))) {
    return false;
  }
  if (isNaN(parseInt(d.slice(8, 10)))) {
    return false;
  }
  if (isNaN(parseInt(d.slice(5, 7)))) {
    return false;
  }

  return true;
};

export const unescapeHTML = (htmlString: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  return doc.documentElement.textContent;
};
